import { ROUTE_IDS } from '../experience/routes/ids.js';
import { getPersonaAccessProfile, PERSONA_ACCESS_PROFILE_REGISTRY, } from './personas/persona-access-profile.registry.js';
const RESOURCE_KIND_TO_ADMIN_RESOURCE_ID = {
    ORGANIZATIONS: 'platform-organizations',
    PLATFORM_MODULES: 'platform-modules',
    PLATFORM_USERS: 'platform-users',
    BRANCHES: 'organization-branches',
    ORGANIZATION_MODULES: 'organization-module-activations',
    ORGANIZATION_USERS: 'organization-users',
    ROLES: 'organization-roles',
    CLIENTS: 'organization-clients',
};
export function getPersonaPolicy(persona) {
    return PERSONA_ACCESS_PROFILE_REGISTRY[persona];
}
export function getPersonaLandingRoute(persona) {
    return getPersonaAccessProfile(persona).navigation.landingRouteId;
}
export function getPersonaPrimaryNavigation(persona) {
    return [...getPersonaAccessProfile(persona).navigation.primaryRouteIds];
}
export const SELF_SERVICE_ACCOUNT_ROUTES = [
    ROUTE_IDS.SETTINGS_PROFILE,
    ROUTE_IDS.SETTINGS_PREFERENCES,
    ROUTE_IDS.SETTINGS_MFA,
    ROUTE_IDS.SETTINGS_PASSWORD,
    ROUTE_IDS.SETTINGS_SESSIONS,
    ROUTE_IDS.SETTINGS_SECURITY,
];
export function getPersonaAvatarNavigation(persona) {
    return [...getPersonaAccessProfile(persona).navigation.avatarRouteIds];
}
export function canPersonaManageResource(persona, resourceKind) {
    const profile = getPersonaAccessProfile(persona);
    const resourceId = RESOURCE_KIND_TO_ADMIN_RESOURCE_ID[resourceKind];
    return profile.administration.resourceIds.includes(resourceId);
}
export function getPersonaDataVisibility(persona) {
    const profile = getPersonaAccessProfile(persona);
    const organizationBusinessData = profile.scope.ownershipPolicy === 'OWN_CLIENT'
        ? 'OWN_CLIENT'
        : profile.scope.ownershipPolicy === 'ASSIGNED_CLIENTS'
            ? 'ASSIGNED_CLIENTS'
            : profile.scope.ownershipPolicy === 'ACTIVE_ORGANIZATION'
                ? 'ACTIVE_ORGANIZATION'
                : profile.delegation.organizationDataRequiresDelegation
                    ? 'DELEGATED_ONLY'
                    : 'NONE';
    return {
        platformMetadata: profile.scope.allowedKinds.includes('PLATFORM') ||
            profile.scope.allowedKinds.includes('SYSTEM'),
        organizationBusinessData,
    };
}
export function canPersonaSwitchContext(persona, contextKind) {
    const profile = getPersonaAccessProfile(persona);
    return contextKind === 'organization'
        ? profile.context.maySwitchOrganization
        : profile.context.maySwitchBranch;
}
export function canPersonaSelectResourceScope(persona, scopeKind) {
    const profile = getPersonaAccessProfile(persona);
    return scopeKind === 'client'
        ? profile.context.maySelectClient
        : profile.context.maySelectPortfolio;
}
